import React, { useEffect } from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Problem from "./components/Problem";
import Solution from "./components/Solution";
import Mission from "./components/Mission";
import Pricing from "./components/Pricing";
import About from "./components/About";
import Customers from "./components/Customers";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Mission />
        <Pricing />
        <About />
        <Customers />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
